import React, { Fragment } from 'react';
import { Router } from '@reach/router';
/** Data Services */
import { DataService } from './Services/DataService';
import { JobStore } from './Services/JobStore';
import { ProjectStore } from './Services/ProjectStore';
/** Scenes */
import { BeenHereBefore } from './Components/BeenHereBefore';
import { LandingGame } from './Scenes/LandingGame/LandingGame';
import { About } from './Scenes/About/About';
import { Work } from './Scenes/Work/Work';
import { Play } from './Scenes/Play/Play';
import { Project } from './Scenes/Project/Project';
import { Contact } from './Scenes/Contact/Contact';
/** Footer */
import { Footer } from './Components/Footer';
/** Shared data source & stores */
const dataService = DataService();
const jobStore = JobStore(dataService);
const projectStore = ProjectStore(dataService);

const EmptyComp = () => <div />;

const Wrapper = props => {
  if (process.env.NODE_ENV === 'production') {
    return <Fragment>{props.children}</Fragment>;
  } else {
    return <React.StrictMode>{props.children}</React.StrictMode>;
  }
};

export class App extends React.Component {
  handleKeyDown = event => {
    // enable backspace navigation
    // when not focused on input elements
    if ((event.keyCode === 8) & (event.target.localName !== 'input')) {
      window.history.back();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
  }

  render() {
    return (
      <Wrapper>
        <Fragment>
          <Router>
            <LandingGame path="landing" />
            <About path="about" />
            <Work path="work" jobStore={jobStore} />
            <Play path="play" projectStore={projectStore} />
            <Project path="play/:projectId" projectStore={projectStore} />
            <Contact path="contact" />
            <BeenHereBefore default />
          </Router>
          <Router primary={false}>
            <Footer path="about" />
            <Footer path="work" />
            <Footer path="play" />
            <Footer path="contact" />
            <EmptyComp default />
          </Router>
        </Fragment>
      </Wrapper>
    );
  }
}
